module.exports = __webpack_public_path__ + "static/media/defaultprofile.7860d8d8.png";